module.exports = ".customFlashMessage\r\n{\r\n  background-color: red;\r\n}\r\n\r\n.fc .fc-toolbar > * > :first-child {\r\n    margin-left: 0;\r\n    font-size: 1.3em;\r\n}\r\n\r\n#calendar{\r\n  height:500px;\r\n\r\n\r\n}\r\n\r\n.container{\r\n  font-color:#535353 !important;\r\n  min-width:90% !important;\r\n\r\n}\r\n\r\n.subcontainer{\r\n  padding-left:5%;\r\n  padding-right:5%;\r\n}\r\n\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/meeting/meeting.component.css
// module id = ./src/app/components/meeting/meeting.component.css
// module chunks = main